import { render } from "./FunctionsCatalogDetail.vue?vue&type=template&id=698c2a9b&ts=true"
import script from "./FunctionsCatalogDetail.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogDetail.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogDetail.vue?vue&type=style&index=0&id=698c2a9b&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__